export * from './DataChartBarsXyVUpIcon';
export * from './DataChartBarsXyVUpIcon16Light';
export * from './DataChartBarsXyVUpIcon16Regular';
export * from './DataChartBarsXyVUpIcon16Solid';
export * from './DataChartBarsXyVUpIcon20Light';
export * from './DataChartBarsXyVUpIcon20Regular';
export * from './DataChartBarsXyVUpIcon20Solid';
export * from './DataChartBarsXyVUpIcon24Regular';
export * from './DataChartBarsXyVUpIcon24Solid';
export * from './DataChartBarsXyVUpIcon32Regular';
export * from './DataChartBarsXyVUpIcon64Regular';
